<template>
    <div>
        <div v-if="$can('read', 'settlement')">
            <admin-queue></admin-queue>
        </div>
        <div v-else>
            <user-queue></user-queue>
        </div>
    </div>
</template>

<script>
    import AdminQueue from "@/views/settlement/AdminQueue";
    import UserQueue from "@/views/settlement/UserQueue";

    export default {
        components: {
            AdminQueue,
            UserQueue,
        },
    }
</script>
